// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__IQ4_i","range":"MonthRangeSwitch_range__1cZdG","disabled":"MonthRangeSwitch_disabled__3hXBv"};